// @ts-check
// Botões fixados no cabeçalho da lista (doc 15, seção 6.1; contrato 08-contrato-comandos-atalhos, seção 5): até dois
// comandos frequentes ao lado de "+ Novo", gravados na view. O alfinete abre a escolha; comandos que o papel não pode
// usar não viram botão mesmo que alguém os tenha fixado.
import { html } from 'htm/preact';
import { useRef, useState } from 'preact/hooks';
import { Button, IconButton } from '../../ui/button.js';
import { Dropdown, DropdownMenuHeader, DropdownMenuItems, MenuItem } from '../../ui/dropdown.js';
import { resolvePinnedListCommands } from '../../lib/command-registry.js';
import { MAXIMUM_PINNED_LIST_COMMANDS } from '../../../../shared/command-menu/pinned-commands.js';
import { t } from '../../i18n/index.js';
import { getCommandLabel, getListCommands, runCommand, togglePinnedListCommand } from './command-actions.js';

/**
 * @param {{ objectMetadata: import('../../lib/field-metadata.js').ObjectMetadata, view: import('../../data/metadata-store.js').View }} props
 */
export function PinnedListCommands({ objectMetadata, view }) {
  const anchorRef = useRef(/** @type {HTMLSpanElement | null} */ (null));
  const [isOpen, setIsOpen] = useState(false);
  const listCommands = getListCommands(objectMetadata, view);
  const pinnable = listCommands.filter((command) => command.pinnableKey);
  const pinned = resolvePinnedListCommands(listCommands, view.pinnedCommandKeys);
  const pinnedKeys = view.pinnedCommandKeys ?? [];
  // a view sintética (objeto sem view semeada) não existe no servidor
  const canPin = !view.id.startsWith('fallback-');
  return html`<span class="pinned-list-commands" data-testid="pinned-list-commands">
    ${pinned.map((command) => html`<${Button}
      key=${command.id}
      icon=${command.icon}
      title=${getCommandLabel(command)}
      size="small"
      variant="secondary"
      data-testid=${`pinned-command-${command.pinnableKey}`}
      onClick=${() => runCommand(command, { list: { objectMetadata, view } })}
    />`)}
    ${canPin
      ? html`<span ref=${anchorRef}>
          <${IconButton} icon="IconPin" size="small" variant="tertiary" ariaLabel=${t('commands.pinned.manage')} onClick=${() => setIsOpen(!isOpen)} />
          <${Dropdown} anchorRef=${anchorRef} isOpen=${isOpen} onClose=${() => setIsOpen(false)} placement="bottom-end" width=${260}>
            <${DropdownMenuHeader} title=${t('commands.pinned.title', { count: MAXIMUM_PINNED_LIST_COMMANDS })} />
            <${DropdownMenuItems}>
              ${pinnable.map((command) => html`<${MenuItem}
                key=${command.pinnableKey}
                icon=${command.icon}
                text=${getCommandLabel(command)}
                multiSelect=${true}
                selected=${pinnedKeys.includes(/** @type {string} */ (command.pinnableKey))}
                onClick=${() => togglePinnedListCommand(view, /** @type {string} */ (command.pinnableKey))}
              />`)}
            <//>
            <div class="pinned-list-commands-hint">${t('commands.pinned.hint')}</div>
          <//>
        </span>`
      : null}
  </span>`;
}
